import Icons from "./utils/Icons.js";
import ComponentFactory from "./ComponentFactory.js";

class Main {
  constructor() {
    this.init();
  }

  init() {
    document.documentElement.classList.add("has-js");
    

    new ComponentFactory();

    Icons.load();

  }
}
new Main();